import { useState } from "react";
import { useTranslation } from "@coworker/locales";
import { Store } from "../../shared/types/store";
import { StoreEnvironmentSelector } from "../../home/components/Profile/StoreEnvironment/StoreEnvironmentSelector";
import { SwitcherSheet } from "../../home/components/Profile/StoreEnvironment/SwitcherSheet";

interface StoreSwitcherProps {
  labelKey: string;
  activeStore: Store;
  stores: Store[];
  loading: boolean;
  handleSwitchStore: (storeId: string) => void;
}

const StoreSwitcher = ({
  labelKey,
  activeStore,
  stores,
  loading,
  handleSwitchStore,
}: StoreSwitcherProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <StoreEnvironmentSelector
        id="team-management-store-selector"
        value={
          !activeStore?.name
            ? t("chooseAnOptionString")
            : `${activeStore.storeId} - ${activeStore.name}`
        }
        label={labelKey}
        validationMsg="pleaseSelectAStoreString"
        selectedItem={activeStore}
        loading={loading}
        onClick={() => setIsOpen(true)}
      />

      <SwitcherSheet
        titleKey={labelKey}
        placeholderKey="searchStoreString"
        items={stores}
        selectedItem={activeStore}
        getItemLabel={(store) => `${store.storeId} - ${store.name}`}
        getItemKey={(store) => store.storeId}
        onSelect={(store) => handleSwitchStore(store.storeId)}
        loading={loading}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </>
  );
};

export default StoreSwitcher;
